module.exports = __webpack_public_path__ + "img/zdd_invite_tx_1.1678280a.png";